import { Controller } from "@hotwired/stimulus"
import { userLocaleToBcp47 } from "../../utils/bcp47.util"

// Connects to data-controller="documents--pdf-locale-sync"
// Moves the PDF locale to the language's default region when the user picks a
// PDF language. A document's saved pdf_locale is a choice of its own (en-GB
// under English, de-AT under German): on page load it is kept when the select
// offers it, and otherwise — no saved value, or one the picker no longer lists
// (es-US, an import's odd culture) — filled from the language, so the next
// save never writes whichever option the browser happened to select.
export default class extends Controller {
  static targets = ["pdfLanguage", "pdfLocale"]
  static values = { savedLocale: String }

  connect() {
    if (this.#hasOption(this.savedLocaleValue)) return

    if (this.hasPdfLanguageTarget && this.hasPdfLocaleTarget) {
      const pdfLanguage = this.pdfLanguageTarget.value
      if (pdfLanguage) {
        this.#syncLocaleFromLanguage(pdfLanguage)
      }
    }
  }

  update(event) {
    const pdfLanguage = event.target.value
    if (!pdfLanguage) return

    this.#syncLocaleFromLanguage(pdfLanguage)
  }

  // Syncs PDF locale to match the selected PDF language
  #syncLocaleFromLanguage(pdfLanguage) {
    if (!this.hasPdfLocaleTarget) return

    // Convert PDF language (2-char locale code) to BCP 47 format for PDF locale
    const pdfLocale = userLocaleToBcp47(pdfLanguage)

    if (this.#hasOption(pdfLocale)) {
      this.pdfLocaleTarget.value = pdfLocale
    }
  }

  #hasOption(locale) {
    if (!locale || !this.hasPdfLocaleTarget) return false
    return Array.from(this.pdfLocaleTarget.options).some((option) => option.value === locale)
  }
}
